import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import Select from 'react-select';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { FormataTelefone } from '@/shared/utils/telefones';
import { GetDefensoria, SetDefensoria, DeleteDefensoria, GetDefensorias, } from '@/modules/structure/defensoria/defensoria.service';
import { GetDiretorias } from '@/modules/structure/diretoria/diretoria.service';
import { GetPredios } from '@/modules/structure/predio/predio.service';
import { useNavigate } from 'react-router-dom';
import { ReadDefensoriaDto } from '@/api.types';
import { defensoriaFormSchema } from '@/modules/structure/defensoria/defensoria.schema';
import {
  FieldError,
  formControlClass,
  formSelectClass,
  getNestedFieldError,
  hasNestedFieldError,
} from '@/shared/components/forms/FormFieldFeedback';
import { normalizeDefensoriaFormFromApi } from '@/modules/structure/defensoria/defensoria-form.utils';
import { numberInputValueAs } from '@/shared/utils/formZod.utils';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  SubmitHandler,
  useController,
  useForm,
  useFormState,
  type FieldErrors,
  type Resolver,
} from 'react-hook-form';
import { Tabelas } from '@/shared/constants/tables';
import { readComarca } from '@/modules/structure/comarca/comarca.service';
import { readVara } from '../vara/vara.service';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

interface IOpcao { value: number; label: string; }

export default function DefensoriaEditPage() {

  const { register, handleSubmit, reset, getValues, setValue, control } = useForm<ReadDefensoriaDto>({
    resolver: zodResolver(defensoriaFormSchema as never) as Resolver<ReadDefensoriaDto>,
    mode: 'onTouched',
    reValidateMode: 'onChange',
    shouldFocusError: false,
    defaultValues: { maximo_estagiarios: 0, ordem: 0 },
  });
  const { errors } = useFormState({ control });

  const { setActions } = useBreadcrumbActions();
  const { field: fielddefensoriasubstituta1 } = useController({ name: 'defensoriasubstituta1', control });
  const { field: fielddefensoriasubstituta2 } = useController({ name: 'defensoriasubstituta2', control });
  const { field: fielddiretoria } = useController({ name: 'diretoria', control });

  const navigate = useNavigate();
  const params = useParams();

  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const id = params.id ? Number(params.id) : 0;
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  useEffect(() => {
    setActions({
      secondary: { label: 'Novo', href: Links.Defensoria_Criar, onClick: () => { } },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions]);

  const [varas, setVaras] = useState<IOpcao[]>([]);
  const [comarcas, setComarcas] = useState<IOpcao[]>([]);
  const [predios, setPredios] = useState<IOpcao[]>([]);
  const [defensorias, setDefensorias] = useState<IOpcao[]>([]);
  const [diretorias, setDiretorias] = useState<IOpcao[]>([]);
  const [loaded, setLoaded] = useState<boolean>(false);

  async function buscar() {
    if (id > 0)
      await GetDefensoria(id)
        .then((result) => {
          if (result) {
            const normalized = normalizeDefensoriaFormFromApi(result);
            if (normalized.telefone?.numero) {
              normalized.telefone.numero = FormataTelefone(normalized.telefone.numero);
            }
            reset(normalized);
          }
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
  }

  useEffect(() => {
    Promise.all([
      readVara({ skip: 0, take: 1000 }).then((result) => {
        setVaras(
          result[0].map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
      }),
      readComarca({ skip: 0, take: 1000 }).then((result) => {
        setComarcas(
          result[0].map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
      }),
      GetPredios(0, 1000).then((result) => {
        setPredios(
          result.objects.map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
      }),
      GetDefensorias(0, 1000).then((result) => {
        setDefensorias(
          result.objects.map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
      }),
      GetDiretorias(0, 1000).then((result) => {
        setDiretorias(
          result.objects.map((item) => {
            return { value: item.id, label: item.nome };
          }),
        );
      }),
      buscar(),
    ])
      .then(() => setLoaded(true))
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, []);

  const onSubmit: SubmitHandler<ReadDefensoriaDto> = (data) => {
    setIsLoading(true);
    const dados: ReadDefensoriaDto = {
      id: id,
      comarca: { id: Number(data.comarca?.id) },
      defensoriasubstituta1: {
        id: Number(data.defensoriasubstituta1?.id),
      },
      defensoriasubstituta2: {
        id: Number(data.defensoriasubstituta2?.id),
      },
      nome: data.nome,
      codigo: data.codigo,
      ordem: data.ordem,
      predio: { id: Number(data.predio?.id) },
      vara: { id: Number(data.vara?.id) },
      exibirrelatorio: data.exibirrelatorio,
      relatoriosAtividadesHabilitado: data?.relatoriosAtividadesHabilitado ?? false,
      maximo_estagiarios: data.maximo_estagiarios,
      anotacao: data.anotacao,
      criminal: data?.criminal ?? false,
      civel: data?.civel ?? false,
      telefone: data.telefone,
      diretoria: data.diretoria?.id ? { id: Number(data.diretoria.id) } : undefined,
    } as ReadDefensoriaDto;

    SetDefensoria(dados)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.Defensoria_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      })
      .finally(() => setIsLoading(false));
  };

  const onInvalid = (fieldErrors: FieldErrors<ReadDefensoriaDto>) => {
    if (import.meta.env.DEV) {
      console.warn('[DefensoriaEdit] Validação:', fieldErrors);
    }
    toast.error('Corrija os campos destacados antes de salvar.');
  };

  const handleExcluir = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setModalExcluirShow(false);
    DeleteDefensoria(id)
      .then((res) => {
        toast.success(res + '');
        navigate(`${Links.Defensoria_Index}`);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  };

  if (!loaded) return <Loading />;

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3>Defensoria</h3>
        </div>
      </div>
      <hr className="pb-4" />

      <form onSubmit={(event) => { void handleSubmit(onSubmit, onInvalid)(event); }} >
        <div className="row">
          <div className="col-md-1">
            <label htmlFor="ordem" className="form-label">
              Ordem:{' '}
            </label>
            <input
              id="ordem"
              title="Ordem no relatório"
              type="number"
              className={formControlClass(!!errors.ordem)}
              min={0}
              {...register('ordem', { setValueAs: numberInputValueAs })}
            />
            <FieldError message={errors.ordem?.message} />
          </div>



          <div className="col-md-2">
            <div>
              <label htmlFor="codigo" className="form-label">
                Código:{' '}
              </label>
              <input
                id="codigo"
                title="Código"
                type="text"
                className={formControlClass(!!errors.codigo)}
                {...register('codigo')}
              />
              <FieldError message={errors.codigo?.message} />
            </div>
          </div>

          <div className="mb-3 col-md-6">
            <label htmlFor="nome" className="form-label">
              Nome Defensoria: <span className="text-danger">*</span>
            </label>
            <input
              id="nome"
              title="Nome"
              type="text"
              className={formControlClass(!!errors.nome)}
              {...register('nome')}
            />
            <FieldError message={errors.nome?.message} />
          </div>

          <div className="mb-3 col-md-3">
            <label htmlFor="vara" className="form-label">
              Vara: <span className="text-danger">*</span>
            </label>
            <select
              id="vara"
              title="Vara"
              className={formSelectClass(!!errors.vara?.id)}
              {...register('vara.id')}
            >
              {varas.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
            <FieldError message={errors.vara?.id?.message} />
          </div>

          <div className="mb-3 col-md-6">
            <label htmlFor="defensoriasubstituta1" className="form-label">
              1ª Defensoria Substituta:{' '}
            </label>
            <Select
              id="defensoriasubstituta1"
              name="defensoriasubstituta1"
              isClearable
              options={[{ label: '', value: '' }, ...defensorias]}
              value={
                fielddefensoriasubstituta1.value
                  ? defensorias.find(
                    (a) => a.value === fielddefensoriasubstituta1.value?.id,
                  )
                  : { label: '', value: '' }
              }
              onChange={(e) => {
                const defSelecionada = defensorias!.find(
                  (a) => a.value === e?.value,
                );
                const novaDefensoria = defSelecionada
                  ? ({
                    id: defSelecionada.value,
                    nome: defSelecionada.label,
                  } as ReadDefensoriaDto)
                  : undefined;
                fielddefensoriasubstituta1.onChange(novaDefensoria);
              }}
              onBlur={fielddefensoriasubstituta1.onBlur}
              styles={
                hasNestedFieldError(errors, 'defensoriasubstituta1')
                  ? {
                      control: (base) => ({
                        ...base,
                        borderColor: '#dc3545',
                        boxShadow: '0 0 0 0.25rem rgba(220, 53, 69, 0.25)',
                      }),
                    }
                  : undefined
              }
            />
            <FieldError
              message={
                getNestedFieldError(errors, 'defensoriasubstituta1')?.message
                ?? getNestedFieldError(errors, 'defensoriasubstituta1.id')?.message
              }
            />
          </div>

          <div className="mb-3 col-md-6">
            <label htmlFor="defensoriasubstituta2" className="form-label">
              2° Defensoria Subsitituta:{' '}
            </label>
            <Select
              id="defensoriasubstituta2"
              name="defensoriasubstituta2"
              isClearable
              options={[{ label: '', value: '' }, ...defensorias]}
              value={
                fielddefensoriasubstituta2.value
                  ? defensorias.find(
                    (a) => a.value === fielddefensoriasubstituta2.value?.id,
                  )
                  : { label: '', value: '' }
              }
              onChange={(e) => {
                const defSelecionada = defensorias!.find(
                  (a) => a.value === e?.value,
                );
                const novaDefensoria = defSelecionada
                  ? ({
                    id: defSelecionada.value,
                    nome: defSelecionada.label,
                  } as ReadDefensoriaDto)
                  : undefined;
                fielddefensoriasubstituta2.onChange(novaDefensoria);
              }}
              onBlur={fielddefensoriasubstituta2.onBlur}
              styles={
                hasNestedFieldError(errors, 'defensoriasubstituta2')
                  ? {
                      control: (base) => ({
                        ...base,
                        borderColor: '#dc3545',
                        boxShadow: '0 0 0 0.25rem rgba(220, 53, 69, 0.25)',
                      }),
                    }
                  : undefined
              }
            />
            <FieldError
              message={
                getNestedFieldError(errors, 'defensoriasubstituta2')?.message
                ?? getNestedFieldError(errors, 'defensoriasubstituta2.id')?.message
              }
            />
          </div>

          <div className="mb-3 col-md-4">
            <label htmlFor="comarca" className="form-label">
              Comarca: <span className="text-danger">*</span>
            </label>
            <select
              id="comarca"
              title="Comarca"
              className={formSelectClass(!!errors.comarca?.id)}
              {...register('comarca.id')}
            >
              {comarcas.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
            <FieldError message={errors.comarca?.id?.message} />
          </div>
          <div className="mb-3 col-md-4">
            <label htmlFor="predio" className="form-label">
              Unidade: <span className="text-danger">*</span>
            </label>
            <select
              id="predio"
              title="Prédio"
              className={formSelectClass(!!errors.predio?.id)}
              {...register('predio.id')}
            >
              {predios.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
            <FieldError message={errors.predio?.id?.message} />
          </div>

          <div className="mb-3 col-md-4">
            <label htmlFor="diretoria" className="form-label">
              Diretoria:{' '}
            </label>
            <Select
              id="diretoria"
              name="diretoria"
              isClearable
              options={[{ label: '', value: '' }, ...diretorias]}
              value={
                fielddiretoria.value
                  ? diretorias.find(
                    (a) => a.value === fielddiretoria.value?.id,
                  )
                  : { label: '', value: '' }
              }
              onChange={(e) => {
                const dirSelecionada = diretorias!.find(
                  (a) => a.value === e?.value,
                );
                const novaDiretoria = dirSelecionada
                  ? ({
                    id: dirSelecionada.value,
                    nome: dirSelecionada.label,
                  })
                  : undefined;
                fielddiretoria.onChange(novaDiretoria);
              }}
              onBlur={fielddiretoria.onBlur}
              styles={
                hasNestedFieldError(errors, 'diretoria')
                  ? {
                      control: (base) => ({
                        ...base,
                        borderColor: '#dc3545',
                        boxShadow: '0 0 0 0.25rem rgba(220, 53, 69, 0.25)',
                      }),
                    }
                  : undefined
              }
            />
            <FieldError
              message={
                getNestedFieldError(errors, 'diretoria')?.message
                ?? getNestedFieldError(errors, 'diretoria.id')?.message
              }
            />
          </div>

          <div className="col-md-4 p-3">
            <div className="card">
              <div className="card-body row">
                <div className="mb-3 col-md-4">
                  <label htmlFor="ddd" className="form-label">
                    DDD:
                  </label>
                  <input
                    id="ddd"
                    title="DDD"
                    type="number"
                    className={formControlClass(!!errors.telefone?.ddd)}
                    {...register('telefone.ddd', { setValueAs: numberInputValueAs })}
                    min={0}
                    max={99}
                  />
                  <FieldError message={errors.telefone?.ddd?.message} />
                </div>
                <div className="mb-3 col-md-8">
                  <label htmlFor="numero" className="form-label">
                    Telefone:
                  </label>
                  <input
                    id="numero"
                    title="Número Telefone"
                    type="text"
                    className={formControlClass(!!errors.telefone?.numero)}
                    maxLength={10}
                    {...register('telefone.numero', {
                      onChange: (e) => {
                        const value = e.target.value;
                        setValue('telefone.numero', FormataTelefone(value), { shouldValidate: true });
                      },
                    })}
                  />
                  <FieldError message={errors.telefone?.numero?.message} />
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <label htmlFor="anotacao" className="form-label">
              Anotações:
            </label>
            <input id="anotacao" type="text" className="form-control" {...register('anotacao')} />

            <label htmlFor="maximo_estagiarios" className="form-label">
              Max. Estagiarios: <span className="text-danger">*</span>
            </label>
            <input
              id="maximo_estagiarios"
              title="Máximo de estagiários"
              type="number"
              className={formControlClass(!!errors.maximo_estagiarios)}
              min={0}
              max={99}
              {...register('maximo_estagiarios', { setValueAs: numberInputValueAs })}
            />
            <FieldError message={errors.maximo_estagiarios?.message} />
          </div>

          <div className="col-md-4 mb-3">
            <div className="form-check" title="Exibir no relatório de lotações." >
              <input id="ativo" type="checkbox" className="form-check-input" {...register('exibirrelatorio')} />
              <label htmlFor="ativo">
                Exibir no relatório de vínculos.
              </label>
            </div>
            <div className="form-check" title="Habilita relatórios de atividades para esta defensoria.">
              <input id="relatoriosAtividadesHabilitado" type="checkbox" className="form-check-input" {...register('relatoriosAtividadesHabilitado')} />
              <label htmlFor="relatoriosAtividadesHabilitado">
                Habilitar relatórios de atividades.
              </label>
            </div>
            <div className="form-check" title="Defensoria criminal.">
              <input id="criminal" type="checkbox" className="form-check-input" {...register('criminal')} />
              <label htmlFor="criminal">
                Defensoria criminal.
              </label>

            </div>
            <div className="form-check" title="Defensoria cível.">
              <input id="civel" type="checkbox" className="form-check-input" {...register('civel')} />
              <label htmlFor="civel">
                Defensoria cível.
              </label>
            </div>
          </div>


          <div className="mb-3 col-md-7" title="Anotações ou observações">

          </div>






          <EditadoPorRodape
            dados={{
              editadoPor: { username: getValues().editadoPor?.username },
              editadoEm: getValues().editadoEm,
            }}
          />
          <div>
            <BotoesSalvarExcluir
              isLoading={isLoading}
              texto={btnSalvar}
              textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
              id={id}
              onExcluirClick={() => setModalExcluirShow(true)}
            />
          </div>
        </div>
      </form>

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      ></ModalExcluir>
      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.defensoria}
        idRegistro={id}
      ></ModalHistorico>
    </>
  );
}
